




































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import ImageUpload from '@/app/ui/components/ImageUpload/index.vue'
import controller, {
  Dropdown,
} from '@/app/ui/controllers/DriverAnnouncementController'
import { Utils } from '@/app/infrastructures/misc'
import Modal from '@/app/ui/components/Modal/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import DateTimePicker from '@/app/ui/components/DateTimePicker/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import dayjs from 'dayjs'
import IconWarningTriangle from '@/app/ui/assets/icon_warning_triangles.vue'
import MultiselectV2 from '@/app/ui/components/MultiselectV2/index.vue'
import routeController from '@/app/ui/controllers/RouteController'
import { LetterCode } from '@/domain/entities/Route'

interface Form {
  announcementRawImage: File[] | Array<undefined>[]
  announcementTitle: string
  announcementBody: string
  announcementImage?: string | null
  startAt: string
  endAt: string
  location: Dropdown[]
  courierTypeValid: Dropdown | null
  ctaName?: string
  ctaUrl?: string
}

interface ErrorField {
  announcementTitle: boolean
  announcementBody: boolean
  announcementImage: boolean
  startAt: boolean
  endAt: boolean
  ctaName: boolean
  courierTypeValid: boolean
}

@Component({
  components: {
    TextInput,
    Button,
    Modal,
    LoadingOverlay,
    DateTimePicker,
    DropdownSelect,
    ImageUpload,
    IconWarningTriangle,
    MultiselectV2
  },
})
export default class CreateDriverAnnouncementPage extends Vue {
  controller = controller
  routeController = routeController
  form: Form = {
    announcementRawImage: [],
    announcementTitle: '',
    announcementBody: '',
    announcementImage: null,
    startAt: '',
    endAt: '',
    location: [],
    courierTypeValid: null,
    ctaName: '',
    ctaUrl: '',
  }
  errorField: ErrorField = {
    announcementTitle: false,
    announcementBody: false,
    announcementImage: false,
    endAt: false,
    startAt: false,
    ctaName: false,
    courierTypeValid: false
  }
  confirmationModal = false
  successModal = false

  districtOptions: Dropdown[] = this.controller.districts

  created(): void {
    routeController.getLetterCodes()
  }

  get courierTypeOptions(): Dropdown[] {
    return controller.constant.courierTypeOptions
  }


  get announcementImageErrorMessage(): string {
    return this.errorField.announcementImage ? 'Maks. size : 2 MB, Format : .jpg .png .jpeg Rekomendasi Dimensi 2 : 4, (contoh: 200px X 800px)' : ''
  }

  private onSearchDistrict(query: string): void {
    let res: Array<Dropdown> = []

    if (query === '') {
      this.districtOptions = routeController.letterCodes.map((route) => {
        return {
          label: <string>route.lc,
          value: <string>route.lc
        }
      })
    }

    routeController.letterCodes.forEach((route) => {
      if ((<string>route.lc).toUpperCase().includes(query.toUpperCase())) {
        res.push({
          label: <string>route.lc,
          value: <string>route.lc
        })
      }
    })

    this.districtOptions = res
  }

  private async changeImage(file: File): Promise<void> {
    const image = await controller.uploadImage(file)
    this.form.announcementRawImage = [file]
    this.form.announcementImage = image as string
    this.errorField.announcementImage = false
  }

  private removeErrorField(key: string): void {
    this.errorField[key as keyof ErrorField] = false
  }

  private onRemoveAnnouncementImage(): void {
    this.form.announcementRawImage = []
    this.form.announcementImage = ''
  }

  private onErrorAnnouncementImage(): void {
    this.errorField.announcementImage = true
  }

  private openConfirmationModal(): void {
    this.confirmationModal = Boolean(!this.validateAnnouncementForm())
  }

  private validateAnnouncementForm(): boolean {
    return Object.keys(this.errorField).map((key: string) => {
      if (key === 'ctaName') {
        if (Boolean(this.form.ctaUrl) && Boolean(!this.form[key as keyof Form])) {
          this.errorField[key as keyof ErrorField] = true
          return true
        }
      } else if (key === 'announcementImage') {
        return false
      } else {
        return this.errorField[key as keyof ErrorField] = Boolean(!this.form[key as keyof Form])
      }
    }).includes(true)
  }

  private createAnnouncement(): void {
    controller.createAnnouncement({
      announcementTitle: this.form.announcementTitle,
      announcementBody: this.announcementBody,
      announcementImage: this.form.announcementImage,
      startAt: dayjs(this.form.startAt).toISOString(),
      endAt: dayjs(this.form.endAt).toISOString(),
      location:
        this.form.location.length === 0
          ? 'ALL'
          : this.form.location.map(location => location.value).join(','),
      courierTypeValid: <string>this.form.courierTypeValid?.value
    })
  }

  get announcementBody(): string {
    let body = Utils.escapeHTML(this.form.announcementBody).replace(
      /(?:\r\n|\r|\n)/g,
      '<br/>'
    )

    if (this.form.ctaUrl || this.form.ctaName) {
      const style = [
        'background-color: #B82025',
        'border: none',
        'color: white',
        'padding: 10px 32px',
        'text-align: center',
        'text-decoration: none',
        'display: inline-block',
        'font-size: 16px',
        'margin: 4px 2px',
        'cursor: pointer',
        'border-radius: 8px',
        'font-weight: 500',
      ]
      body += `<br/><br/><div style="text-align: center"><a style="${style.join(
        ';'
      )}" href="${this.form.ctaUrl}">${this.form.ctaName}</a></div>`
    }

    return body
  }

  private onCloseSuccessModal(): void {
    this.successModal = false
    this.controller.setIsCreateDriverAnnouncementSuccess(false)
    this.$router.push({ name: 'DriverAnnouncementList' })
  }

  get isUploading(): boolean {
    return controller.isUploading
  }

  get today(): string {
    return dayjs().format('YYYY-MM-DD[T]HH:mm:ss.SSS')
  }

  @Watch('routeController.letterCodes')
  onLetterCodesChanged(data: LetterCode[]): void {
    this.districtOptions = data.map((route) => {
      return {
        label: <string>route.lc,
        value: <string>route.lc
      }
    })
  }

  @Watch('form.announcementTitle')
  setAnnouncementTitle(title: string): void {
    // remove script tag
    this.form.announcementTitle = Utils.removeScriptTags(title)

    // remove special character except emojis
    this.form.announcementTitle = Utils.removeSpecialCharWithEmojis(this.form.announcementTitle)
  }

  @Watch('form.announcementBody')
  setAnnouncementBody(body: string): void {
    // remove script tag
    this.form.announcementBody = Utils.removeScriptTags(body)

    // remove special character except emojis
    this.form.announcementBody = Utils.removeSpecialCharWithEmojis(this.form.announcementBody)
  }

  @Watch('form.ctaName')
  setCTAName(name: string): void {
    // remove script tag
    this.form.ctaName = Utils.removeScriptTags(name)

    // remove special character except emojis
    this.form.ctaName = Utils.removeSpecialCharWithEmojis(this.form.ctaName)
  }

  @Watch('controller.isCreateDriverAnnouncementSuccess')
  setCreateDriverAnnouncementSuccess(success: boolean): void {
    if (success) {
      this.confirmationModal = false
      this.successModal = true
    }
  }

  beforeDestroy(): void {
    this.controller.setIsCreateDriverAnnouncementSuccess(false)
  }
}
